import { isEmpty } from '@sgme/fp';
import { connect } from 'react-redux';
import * as addonSelector from 'state/addonForm/addonForm.selector';
import { getIsTradeEnabled } from 'state/selectors';
import { isStatusWithQuoteButtons, isStatusWithTradeButtons } from 'state/selectors/meta/quote/utils';
import type { AppState } from 'state/state.model';

export interface OwnProps {
  className?: string;
  tabId: string;
}

export interface StateProps {
  hasPriceEnhancer: boolean;
  hasQuoteButtons: boolean;
  hasTradeButtons: boolean;
  hasTradeDoneButton: boolean;
  hasValidationErrors: boolean;
  quoteId?: string;
  isRejected: boolean;
  hasBackToBack: boolean;
}

export type ContentProps = StateProps & OwnProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const quoteId = addonSelector.getLastQuoteId(state, tabId);
  const remunerationMode = addonSelector.getRemunerationMode(state, tabId);
  const priceEnhancementMode = addonSelector.getPriceEnhancementMode(state, tabId, remunerationMode);
  const status = addonSelector.getWorkflowStatus(state, tabId);
  const hasTradableRights = getIsTradeEnabled(state);
  const hasQuoteButtons = isStatusWithQuoteButtons(status, !hasTradableRights);
  const hasTradeButtons = hasTradableRights && isStatusWithTradeButtons(status);
  const hasPriceEnhancer = status === 'QUOTED_TRADABLE' && priceEnhancementMode !== 'None';
  const validationErrors = addonSelector.getValidationErrors(state, tabId);
  const hasValidationErrors = !isEmpty(validationErrors);
  const hasTradeDoneButton = status === 'TRADED';
  const isRejected = status === 'ERROR' || status === 'REJECTED';
  const hasBackToBack = addonSelector.hasBackToBack(state, quoteId);

  return {
    hasPriceEnhancer,
    hasQuoteButtons,
    hasTradeButtons,
    hasTradeDoneButton,
    hasValidationErrors,
    quoteId,
    isRejected,
    hasBackToBack,
  };
};

export const connectContent = connect(mapStateToProps);
